import { BIND_TEMPLATE, CREATE_AND_BIND_TEMPLATE, CREATE_TEMPLATE, enqueueSkyfireMethod, HAS_NOT_SOFT_REFRESHED, HAS_SOFT_REFRESHED, INVALIDATE_TEMPLATE, SOFT_REFRESH_TEMPLATES, unparkSkyfireMethod, URL_CHANGE, } from '../actions';
import { dispatchSkyfireMethods, globals, initSkyfire, rewriteDeeplink } from '../utils';
export const SkyfireTemplateMiddleware = (store) => (next) => (action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    switch (action.type) {
        case CREATE_TEMPLATE:
        case CREATE_AND_BIND_TEMPLATE:
            action.payload.template.id = generateTemplateId(action.payload.template);
            if (action.payload.template.templateData) {
                pushTemplateToBrowserHistory(action.payload.template);
            }
            next(action); // Need to let this action go through here so the template is in the stack
            // when the oncreated methods attempt to execute
            if (action.type === CREATE_TEMPLATE && action.payload.template.onCreated) {
                queueMethods(store.dispatch, action.payload.template.onCreated, action.payload.template.id);
            }
            if (action.type === CREATE_AND_BIND_TEMPLATE && action.payload.template.onBound) {
                queueMethods(store.dispatch, action.payload.template.onBound, action.payload.template.id);
            }
            break;
        case BIND_TEMPLATE:
            const templateStackState = store.getState().TemplateStack;
            if (!((_c = (_b = (_a = templateStackState) === null || _a === void 0 ? void 0 : _a.currentTemplate) === null || _b === void 0 ? void 0 : _b.templateData) === null || _c === void 0 ? void 0 : _c.deeplink) &&
                !((_g = (_f = (_e = (_d = templateStackState) === null || _d === void 0 ? void 0 : _d.currentTemplate) === null || _e === void 0 ? void 0 : _e.innerTemplate) === null || _f === void 0 ? void 0 : _f.templateData) === null || _g === void 0 ? void 0 : _g.deeplink)) {
                pushTemplateToBrowserHistory(action.payload.template);
            }
            else {
                updateTemplateInBrowserHistory(action.payload.template);
            }
            action.payload.template.id = action.payload.owner;
            store.dispatch({ type: HAS_NOT_SOFT_REFRESHED });
            next(action);
            if (action.payload.template.onBound) {
                queueMethods(store.dispatch, action.payload.template.onBound, action.payload.template.id);
            }
            break;
        case URL_CHANGE:
            const newTemplate = store.getState().TemplateStack.urlMap[action.payload.newUrl];
            if (!newTemplate) {
                globals.location.reload();
                return;
            }
            if (newTemplate.id) {
                const parkedMethods = store.getState().SkyfireMethodQueue.parkedMethods[newTemplate.id];
                next(action);
                if (parkedMethods) {
                    store.dispatch(unparkSkyfireMethod(newTemplate.id));
                    parkedMethods.forEach((method) => store.dispatch(enqueueSkyfireMethod({ queue: method.queue, method })));
                }
                if (newTemplate.invalidatedAt) {
                    dispatchSkyfireMethods(store.dispatch, newTemplate, newTemplate.onCreated);
                }
            }
            break;
        case INVALIDATE_TEMPLATE:
            next(action);
            const templateStack = store.getState().TemplateStack;
            const currentTemplate = templateStack.currentTemplate;
            if ((_h = currentTemplate) === null || _h === void 0 ? void 0 : _h.innerTemplate) {
                initSkyfire(store, currentTemplate.innerTemplate.id, true);
            }
            break;
        case SOFT_REFRESH_TEMPLATES:
            next(action);
            const templateStackRefresh = store.getState().TemplateStack;
            const currentTemplateRefresh = templateStackRefresh.currentTemplate;
            if ((_j = currentTemplateRefresh) === null || _j === void 0 ? void 0 : _j.innerTemplate) {
                store.dispatch({ type: HAS_SOFT_REFRESHED });
                initSkyfire(store, currentTemplateRefresh.innerTemplate.id, true);
            }
            break;
        default:
            next(action);
    }
};
function queueMethods(dispatch, methods, owner) {
    methods.forEach((method) => {
        dispatch(enqueueSkyfireMethod({ queue: method.queue, method: Object.assign(Object.assign({}, method), { owner }) }));
    });
}
const idCounter = {};
// https://github.com/lodash/lodash/blob/master/uniqueId.js
function generateTemplateId(template) {
    const prefix = template.interface + '_';
    if (!idCounter[prefix]) {
        idCounter[prefix] = 0;
    }
    const id = ++idCounter[prefix];
    return `${prefix}${id}`;
}
function pushTemplateToBrowserHistory(template) {
    var _a;
    if ((_a = template.templateData) === null || _a === void 0 ? void 0 : _a.deeplink) {
        const location = globals.location;
        if (template.templateData.deeplink === location.pathname) {
            return;
        }
        globals.history.pushState({}, '', rewriteDeeplink(template.templateData.deeplink));
    }
}
function updateTemplateInBrowserHistory(template) {
    var _a;
    if ((_a = template.templateData) === null || _a === void 0 ? void 0 : _a.deeplink) {
        const location = globals.location;
        if (template.templateData.deeplink === location.pathname) {
            return;
        }
        globals.history.replaceState({}, '', rewriteDeeplink(template.templateData.deeplink));
    }
}
